import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { PathListItemModule } from '@portal-core/ui/list/components/path-list-item/path-list-item.module';
import { CollabConflictResolutionDialogComponent } from './collab-conflict-resolution-dialog.component';

@NgModule({
  declarations: [
    CollabConflictResolutionDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    MatTooltipModule,
    PathListItemModule,
    SelfTruncatingPathModule,
    RouterModule
  ],
  exports: [
    CollabConflictResolutionDialogComponent
  ]
})
export class CollabConflictResolutionDialogModule { }
